import axios from "axios";
import store from "../Redux/Store/store";
import { HTTP_ERROR_MESSAGES } from "../Utils/constants";
import swal from "sweetalert";
const baseURL = process.env.REACT_APP_API_KEY;

// const data = store.getState();

// const accessToken = data.LoginData?.accessToken;
// const refreshToken = data.LoginData?.refreshToken;
// let token = accessToken;
// if (isSendRefreshToken) {
//   token = refreshToken;
// }

// const accessToken = localStorage.getItem("accessToken");

export const axiosObj = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});

axiosObj.interceptors.request.use(function (config) {
  // // console.log("Request:", JSON.stringify(config, null, 2));
  const token = localStorage.getItem("accessToken");

  // Add Bearer token for OTP verification endpoints
  if (config.url === "/users/otp_verify" || config.url === "/users/login_by_otp" || 
      config.url === "/users/resend_otp" || config.url === "/users/resend_phone_otp") {
    console.log("Adding Bearer token for OTP endpoint:", config.url, token ? "Token present" : "No token");
  }

  config.headers.Authorization = "Bearer " + token;
  // if (config.url === "/ad/generatePaymentIntent") {
  config.headers["x-access-token"] = token;
  // }
  return config;
});

axiosObj.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // // console.log(error?.response);
    const blacklistUrl = [
      '/business/getdailydeals',
      '/business/getnewinbusiness',
      '/business/getfeaturedbusinesses',
      '/business/getlocalhighlightbusinesses',
      '/business/get_my_interest',
      '/business/get_my_interest_business',
      '/users/getprofile',
      '/business/get_business_detail_by_id',
      '/ad/get_all_ad_plans',
      '/reviews/get_app_reviews',
      '/ad/get_schedules',
      '/ad/get_ad',
      '/business/get_favourite_business',
      '/business/get_interest',
      '/offers/check_user_offer_status'
    ]
    const statusCode = error?.response?.status;
    const errorMessage = HTTP_ERROR_MESSAGES[statusCode];
    if (error && errorMessage && error?.response?.config?.method !== "get" && !blacklistUrl.includes(error?.response?.config?.url)) {
      swal({
        title: '',
        text:
          error.response?.data?.errors?.length > 0
            ? error.response?.data?.errors[0] || 'Action Error'
            : error.response?.data?.message || 'Action Error',
        buttons: false,
        icon: "error",
        timer: 3000,
      });
    }
    return Promise.reject(error);
  }
);
